module.exports = __webpack_public_path__ + "static/media/menuIcon.63547ccd.svg";